'use client'

import { useEffect, useState } from 'react'
import Script from 'next/script'

const GA_ID = 'G-3BQ4316GMP'
const CONSENT_COOKIE = 'gdpr-google-tagmanager=true'

function hasAnalyticsConsent() {
  if (typeof document === 'undefined') {
    return false
  }

  return document.cookie.split('; ').some((cookie) => cookie === CONSENT_COOKIE)
}

export default function GoogleAnalyticsGate() {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const updateConsent = () => {
      setEnabled(hasAnalyticsConsent())
    }

    updateConsent()

    window.addEventListener('analytics-consent-granted', updateConsent)
    window.addEventListener('analytics-consent-denied', updateConsent)

    return () => {
      window.removeEventListener('analytics-consent-granted', updateConsent)
      window.removeEventListener('analytics-consent-denied', updateConsent)
    }
  }, [])

  if (!enabled) {
    return null
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', '${GA_ID}');
        `}
      </Script>
    </>
  )
}
